export default __webpack_public_path__ + "static/cloudator-responsive-menu-features-b6d66bcc6edcdf4e5f439617f5c6a56d.jpg";